import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ReactDOM from 'react-dom';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import _Select from '@material-ui/core/Select';
import { Util, runtime } from '../common';
import { Input, DialogActions, Checkbox, Divider } from '@material-ui/core';
import Button, { Link, OKLink, ClearLink, CloseLink, ModalButton } from './Button';
import Modal, { Sheet } from './Modal';
import { UIComponent, Cluster, combineEvent, mapClusterKey } from './Base';
import { Input as _Input, Selection } from './input/Base';
import { OutlinedButtonMore } from 'codeArt/components/Button';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import CheckIcon from '@material-ui/icons/Check';
import Tooltip from 'codeArt/components/Tooltip';
import Badge from './Badge';

function invalidHandle(o, v) {
    if (!v) return;
    v = o.selectedItems();
    if (Util.type(v) !== "array") {
        v = [v];
    }
    let invalids = v.filter((t) => {
        return t.Invalid;
    }).map((t) => t.Name);

    if (invalids.length > 0) {
        return `${invalids.join('、')}已无效`;
    }
}

export default class Select extends Selection {

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            open: false,
        }
        this.modalMaster = mapClusterKey(this.props.modalMaster);
    }

    handleSheetComplete(v){
        let { onChange } = this.props;
        this.handleChange(v);
        if (onChange)onChange(v);
    }

    getSelectedActions(items){

        if (items.length == 0) return { label: "", values: [] };

        let label = "";
        let values = Util.select(items, (t) => { return t.value;});
        label =  Util.select(items, (t) => { return t.text;}).join(',');

        return {label: label, values: values};
    }

    renderMobile() {
        let { label, options, multiple } = this.props;
        let items = this.selectedItems();
        let selected = this.getSelectedActions(items);
        let color = selected.label?"warning":"blue";

        return (
            <div className="d-flex flex-column">
                <Badge onClick={() => { this.sheet.open(selected.values); }} color={color}>{selected.label || label}</Badge>
                <SelectAction ref={(r) => { this.sheet = r; }} options={options} multiple={multiple} onComplete={(v) => { this.handleSheetComplete(v); }} />
            </div>
        );
    }


    getValidateHandles() {
        let handlers = super.getValidateHandles();
        return [...handlers, invalidHandle];
    }

    isModal() {
        return this.modalMaster;
    }

    getValue() {
        let multiple = this.multiple();
        let value = super.get();
        return multiple ? value : value[0];
    }

    get() {
        let { onClick } = this.props;
        if (this.isModal() || onClick) {
            let multiple = this.multiple();
            let items = this.selectedItems();
            return multiple ? items : items[0];
        }
        else {
            return this.getValue();
        }
    }

    getLabel() {
        let multiple = this.multiple();
        let items = this.selectedItems();
        return multiple ? items.map((t) => t.text || t.label) : (items[0].text || items[0].label);
    }

    getStrings() {  //提供字符串格式的值
        return this.getValue().map((v) => v + '');
    }

    set(v) {
        let { onClick } = this.props;
        this.resetValidate();//后加
        if (Util.empty(v)) v = [];
        else if (Util.type(v) != 'array') {
            v = [v]; //传递进来的值不是数组，所以要转换一下
        }
        let { group, fill } = this.props;
        if (this.isModal() || this.options().length == 0 || onClick) {
            let items = v; //modal模式下赋予选项的完整信息，包括value和text、group
            this.options(items);
            if (group || fill) {
                v = Util.select(items, (t) => {
                    let itemValue = { value: t.value };
                    if (group) itemValue.group = t.group;
                    if (fill) itemValue.fill = t.fill || '';
                    return itemValue
                }); //支持传递对象数组进来，会自动转换
            }
            else {
                v = Util.select(items, (t) => { return t.value || t; }); //支持传递对象数组进来，会自动转换
            }
        }

        super.set(v);
    }

    selectedItems() { //返回{value,text}形式的被选项，如果指定了group,那返回{value,text,group}
        var items = this.options(), values = this.getValue();
        let { group, fill } = this.props;
        let multiple = this.multiple();
        if (multiple) {
            if (group || fill) {
                return items.filter(function (item) {
                    return Util.contains(values, (v) => {
                        return v.value == item.value;
                    });
                });
            }
            else {
                return items.filter(function (item) {
                    return Util.contains(values, item.value);
                });
            }
        }
        let v = values;//单选
        if (group || fill) {
            return items.filter(function (item) { return item.value == v.value; });
        }
        else
            return items.filter(function (item) { return item.value == v; });
    }

    handleOpen(e) {
        this.setState({ open: true });
        this.openModal();
    }

    openModal() {
        let { onClick } = this.props;

        if (this.modalMaster) {
            let modal = Cluster.getMaster(this.modalMaster);
            modal.setSelect(this);
            modal.open({
                fromSelect: true,
                onExit: () => {
                    this.setState({ open: false });
                }
            });
        }

        if (onClick) onClick();
    }


    handleClose(e) {
        this.setState({ open: false });
    }

    multiple() {
        return (this.props.multiple || this.props.group) ? true : false;
    }

    baseClassName = "c-select";

    getGroupItemValue(item) {
        return `${item.group}-${item.value}`;
    }

    getSelectText(options, values) {
        let l = [];
        options.forEach((item, index) => {
            let value = this.getOptionValue(item);
            let selected = values.find(t => t == value) != null;
            if (selected) l.push(item.text || item.label);
        });

        return l.join(', ');
    }

    getReceiveFocus() { //获得用于接收焦点的组件
        if (this.isModal()) return null;//目前不支持弹窗口的选择组件
        return [...document.getElementsByClassName("MuiList-root MuiMenu-list MuiList-padding")].filter(t => t.tagName == "UL")[0];
    }

    getDisabled() {
        let { onClick } = this.props;
        return super.getDisabled() || this.disabledByOptions() && !onClick;
    }

    disabledByOptions() { //如果没有选项，那么不能点击
        if (this.isModal()) return false;//忽略modal模式
        return this.options().length === 0;
    }

    renderMain() {
        let { disabledTip } = this.props;
        let main = super.renderMain();
        if (!disabledTip) return main;
        let disabled = this.getDisabled();
        return disabled ? Tooltip({
            description: disabledTip,
            placement: "top",
            content: main
        }) : main;
    }

    renderInput() {
        let { placeholder, label, emptyable, emptyableLabel } = this.props;
        let { open } = this.state;
        if (this.isModal() && !placeholder) placeholder = "从窗口中选择";

        let { options, multiple, selectValue } = this.getProps();
        return (
            <_Select
                onSelect={(t) => { }}
                ref="select"
                label={label}
                multiple={multiple}
                native={false}
                open={open}
                onOpen={(e) => this.handleOpen(e)}
                onClose={(e) => this.handleClose(e)}
                //value={selectValue+''}  //有时候外界喜欢用整型作为value，但是select组件是不识别的，会有警告，所以这里转成字符串 ()由于改动后引起了BUG，所以不改了
                value={selectValue}
                renderValue={(v) => { return this.getSelectText(options, v) }}
                onChange={(e) => this.handleChange(e.target.value)}
            >
                {
                    placeholder ?
                        <MenuItem value="" disabled>
                            {placeholder}
                        </MenuItem>
                        : null
                }
                {
                    emptyable && !multiple ? <MenuItem value=""><em>{emptyableLabel || "无"}</em></MenuItem> : null
                }
                {
                    options.map((item, index) => {
                        let value = this.getOptionValue(item);
                        let label = item.text || item.label;
                        let selected = multiple ? (selectValue.find(t => t == value) != null) : false;
                        return (
                            Tooltip({
                                props: {
                                    key: index,
                                    value
                                },
                                description: item.help,
                                placement: "left",
                                content: (
                                    <MenuItem
                                        data-gta-title={label}
                                        key={index}
                                        value={value} disabled={item.disabled ? true : false}
                                    >
                                        {multiple ? <Checkbox checked={selected} /> : null}
                                        {label}
                                    </MenuItem>)
                            })
                        )
                    })
                }
            </_Select>
        )
    }


    getOptionValue(option) {
        return option.group ? this.getGroupItemValue(option) : option.value; //在group模式下，需要对赋值给select的value进行转换，确保每一项的值是唯一的
    }

    getProps() {
        let { value } = this.state;
        let { group } = this.props;
        let options = this.options();
        let multiple = this.multiple();

        let selectValue = value;
        if (group) { //在group模式下，需要对赋值给select的value进行转换，确保每一项的值是唯一的
            if (multiple) {
                selectValue = value.map((t) => this.getGroupItemValue(t));
            } else {
                selectValue = this.getGroupItemValue(value);
            }
        }

        return { options, multiple, selectValue };
    }
}

Select.defaultProps = {
    emptyable: true,
    emptyableLabel: '无',
    disabledTip: "暂无数据",
    multiple: false,
    variant: "outlined",
    size: "medium"
}

class SelectAction extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            values: []
        }
    }


    addOrRemove(value) {
        let { multiple } = this.props;
        let { values } = this.state;
        let contains = Util.contains(values, (v) => v == value);

        if (contains)
            values = values.filter((t) => t != value);
        else
            values.push(value);

        if (!multiple && (contains || values.length > 1)) values.shift();

        this.setState({ values });
    }

    complete() {
        let { onComplete, multiple } = this.props;
        let { values } = this.state;

        if (onComplete) onComplete(multiple ? values : values[0]);
        this.close();
    }

    open(values) {
        this.setState({
            values: values || []
        }, () => {
            this.refs.sheet.open();
        })
    };

    close() {
        this.setState({
            values: []
        }, () => {
            this.refs.sheet.close();
        })
    };

    render() {
        let { options } = this.props; let my = this;
        let p = { ...this.props };
        delete p.children; delete p.title; delete p.options;
        if (Util.type(options) === 'function') options = options();
        let { values } = this.state;
        return (
            <Sheet ref="sheet" {...p} header={
                <div className={"d-flex c-flex-1 flex-row justify-content-between align-items-center mx-2"}>
                    <div className={"c-text-s2 c-text-light-blue"} onClick={() => { this.close(); }}>取消</div>
                    <div className={"c-text-s2 c-text-light-blue"} onClick={() => { this.complete(); }}>完成</div>
                </div>
            } >
                <div className="bg-white">
                    {options.map((option, index) => {
                        let selected = Util.contains(values, option.value);
                        return (
                            <SelectAction.Item key={index} selected={selected} last={index == options.length - 1} label={option.text || option.label} color={option.color} onClick={() => { my.addOrRemove(option.value); }} />
                        )
                    })}
                </div>
            </Sheet>
        )
    }
}

SelectAction.defaultProps = {
    options: []
}

SelectAction.Item = (props) => {
    let { label, last, color, selected, onClick } = props;
    color = color || 'dark';
    return [<div key={0} className={`d-flex flex-row justify-content-between align-items-center py-2 c-mh3 c-md-mh4 mx-4`} onClick={onClick}>
        <p className={`c-text-s1 c-text-md-s2 c-ellipsis-1 mb-0 c-text-${color}`}>{label}</p>
        {selected ? <CheckIcon className={"ml-2 c-text-red c-icon-s2"} /> : null}
    </div>, <Divider key={1} />]
}


export class SelectModal extends UIComponent {

    constructor(props) {
        super(props);
        this.state = {
            ...this.state
        }
    }

    setSelect(s) {
        this.select = s;
    }

    setTable(t) { //为modal设置table，并且关联一些行为
        this.table = t;
        let multiple = this.select.multiple();
        this.table.selectMode(multiple ? "checkbox" : "radio");
        t.set(this.select.selectedItems());
    }

    reload(p) {
        let grid = this.refs.grid;
        grid.reload(p);
    }

    open(p) {
        if (!p) p = {};
        p.onExit = combineEvent(p.onExit, () => {
            this.close();
        });
        if (p.fromSelect) {
            this.refs.modal.open(p);
            this.fromSelect = true;
        }
        else {
            this.fromSelect = false;
            //自定义打开
            p = p || {};
            let { multiple, ok, items, reverse } = p;
            let my = this;
            this.ok = ok;
            this.reverse = reverse;
            this.refs.modal.open({
                onEntered: () => {
                    let grid = my.refs.grid;
                    grid.selectMode(multiple ? "checkbox" : "radio");
                    if (items) {
                        if (reverse) { //取反配置
                            grid.reverseSet(items);
                        }
                        else {
                            grid.set(items);
                        }
                    }
                }
            });
        }

    }

    close() {
        if (this.refs.modal)
            this.refs.modal.close();
        this.table = null;
    }

    set() {
        if (this.fromSelect) {
            let table = this.table;
            let keys = this.reverse ? table.reverseGet() : table.get();

            let multiple = this.select.multiple();
            let value = multiple ? keys : keys[0];
            this.select.handleChange(value);

            this.close();
        } else {
            if (this.ok) {
                let value = this.reverse ? this.refs.grid.reverseGet() : this.refs.grid.get();
                if (this.ok(value) === false) return;
                this.close();
            }
        }
    }

    reset() {
        if (this.fromSelect) {
            this.select.reset();
            this.close();
        } else {
            this.refs.grid.reset();
        }
    }

    // componentWillMount() {
    //     super.componentWillMount();

    //     //开启集群，让其他对象可以访问它
    //     let { slave } = this.props;
    //     if (slave) {
    //         this.master = { "modal": mapClusterKey(slave) };
    //         Cluster.openMaster(this);
    //     }
    // }

    componentDidMount() {
        super.componentDidMount();

        //开启集群，让其他对象可以访问它
        let { slave } = this.props;
        if (slave) {
            this.master = { "modal": mapClusterKey(slave) };
            Cluster.openMaster(this);
        }
    }

    renderBody() {
        return <div className="row no-gutters c-mx-0 h-100">
            <div className="col-12 py-4">
                {this.grid("grid", { scrollable: true })}
            </div>
        </div>;
    }

    getManager() {
        if (this.manager) return this.manager();
        return null;
    }

    renderManagerButton(manager) {
        let { label, options, disabledTip } = manager;
        label = label || "管理";
        return <OutlinedButtonMore key="manager" size="md" className={"ml-2"} button={{ leftIcon: SettingsOutlinedIcon }} disabledTip={disabledTip} options={options || []}>{label}</OutlinedButtonMore>
    }

    tools() {
        let { button } = this.props;
        let ok = button && button.ok ? button.ok : { color: "blue", label: "确定选择" };
        let manager = this.getManager();
        return [<ModalButton color={ok.color} key={0} onClick={() => { this.set() }}>{ok.label}</ModalButton>,
        manager ? this.renderManagerButton(manager) : null,
        <ModalButton size="md" color="grey" key={1} onClick={() => { this.close() }}>关闭</ModalButton>];
    }

    render() {
        let { title, size } = this.props;
        let view = this.view ? this.view("grid") : null;
        return (
            <Modal title={title} size={size} ref="modal" tools={this.tools()} containerFull={true}>
                {this.renderBody()}
                {view ? view : null}
            </Modal>
        )
    }

}

SelectModal.defaultProps = {
    title: "请选择",
    size: "md"
}




export class GroupSelectModal extends SelectModal {

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            group: null
        }
        this.tables = [];
    }

    getItems(group) {
        var items = this.select.selectedItems();
        return items.filter((item) => {
            return item.group == group;
        });
    }

    setSelect(s) {
        this.select = s;
        let { group } = this.select.props;
        if (!group) throw new Error("分组选择的Select必须指定格式为 [{value,multiple}] 的group");
        this.setState({
            group
        });
    }

    setTable(t) { //为modal设置table，并且关联一些行为
        let { group } = t.props;
        if (!group) throw new Error("分组选择的表格必须指定group");
        this.tables.push(t);
        var c = this.getConfig(group);
        t.selectMode(c.multiple ? "checkbox" : "radio");

        var items = this.getItems(group);
        t.set(items);
    }

    getConfig(group) {
        let selectGroup = this.state.group;
        return Util.first(selectGroup, (g) => {
            return g.value == group;
        });
    }

    close() {
        this.refs.modal.close();
        this.tables = [];
    }

    set() {
        if (this.fromSelect) {
            var tables = this.tables;
            var value = [];
            tables.forEach((table) => {
                var keys = table.get();
                keys.forEach((t) => {
                    value.push(t);
                });
            });
            this.select.handleChange(value);

            this.close();
        } else {
            // if(this.ok){ //暂不支持独立使用
            //     var value = this.refs.grid.get();
            //     if(this.ok(value) === false) return;
            //     this.close();
            // }
        }
    }


    renderBody() {
        let group = this.state.group;
        if (!group) return null;
        return group.map(({ value, text, label }, i) => {
            var grid = this.grid(value);
            return grid ? <div key={i} className="row no-gutters mx-3 mx-sm-0">
                <div className="col-12">
                    <p className="c-text-s2 c-text-sm-s3 my-2">{text || label}</p>
                </div>
                <div className="col-12">
                    {grid}
                </div>
            </div> : null
        });
    }

}

GroupSelectModal.defaultProps = {
    title: "请选择",
    size: "md"
}


export class Selects extends React.Component {
    constructor(props) {
        super(props);
        this.selects = [];
        this.state = {
            values: [],
            optionsLength: []
        }
    }

    invalidValue(index) {  //处于index位置的值是否为无效的,有值，但是没有对应的选项，那么证明值是无效的，这是因为外部设置的值，和最新的选项不匹配导致的，这时候逻辑要改变
        let select = this.selects[index];
        if (select && select.selectedItems().length == 0) {
            return true;
        }
    }

    onSelectChange(v, { focus }, index) {
        let { levels } = this.props;
        if (index == levels.length - 1) return; //最后一个下拉框，不触发事件

        let { values } = this.state;
        values[index] = v;
        this.setState({
            values
        }, () => {
            if (focus) { //手工选择，那么需要清空后续
                for (let i = index + 1; i < this.selects.length; i++) {
                    this.selects[i].reset();
                }
            }

            let next = this.selects[index + 1];
            if (next) {
                next.loadOptions();
            }
        });
    }

    _onLoadOptions(options, index) {
        let { optionsLength } = this.state;
        let invalid = index > 0 && this.invalidValue(index - 1);
        optionsLength[index] = invalid ? 0 : options.length;
        this.setState({
            optionsLength
        });
    }

    selectIsInvalid(index) {  //选项组件是否为无效
        if (index === 0) return false; //第一个组件始终有效
        let { optionsLength } = this.state;
        let length = optionsLength[index] || 0;
        return length === 0;
    }

    getLoadOptionsParas(load, index) {
        if (index === 0) return load(); //第0个没有参数
        let values = this.state.values;
        let value = values[index - 1];
        if (Util.invalid(value) || Util.empty(value))
            return [];
        return load(value, {
            prev: values[index - 2],
            values: values
        });
    }

    getDisabledTip(index) {
        let { optionsLength, values } = this.state;
        let v = null;
        if (this.props.getDisabledTip) v = this.props.getDisabledTip(index, optionsLength, values);
        return v;
    }

    renderItem({ label, field, required, load, depend, help, disabledTip, selectProps }, col, index) {
        let { slave, invalid } = this.props;
        let isInvalid = this.selectIsInvalid(index);
        let style, className;
        if (invalid === "hidden" && isInvalid) {
            className = '';
            style = { width: 0, overflow: 'hidden' };
        } else {
            className = `col-${col}`;
        }

        disabledTip = disabledTip || this.getDisabledTip(index);
        return (
            <div key={index} className={className} style={style}>
                <Select ref={(r) => { this.selects[index] = r; }} field={field} label={label} required={required} slave={slave} ignoreRecord={true}
                    load={load ? () => { return this.getLoadOptionsParas(load, index); } : null}
                    onLoadOptions={(options) => { this._onLoadOptions(options, index); }}
                    disabled={isInvalid}
                    disabledTip={disabledTip}
                    onChange={(v, e) => { this.onSelectChange(v, e, index); }}
                    depend={depend}
                    help={help}
                    {...selectProps}
                />
            </div>
        );
    }

    reset() {
        this.setState({
            values: [],
            optionsLength: []
        }, () => {
            this.selects.forEach((s, index) => {
                s.reset();
            });

            let root = this.selects[0];
            if (root) {
                root.loadOptions();
            }
        });
    }

    render() {
        let { levels } = this.props;
        if (!levels) return;
        let col = 12 / levels.length;
        return (
            <div className="row">
                {levels.map((level, index) => {
                    return this.renderItem(level, col, index);
                })}
            </div>
        )
    }
}

Selects.defaultProps = {
    align: true, //是否对齐，这用于自适应布局
    invalid: "disabled"
}